export default __webpack_public_path__ + "static/vignesh-a9959369ff892fb0e373d3f002db713e.png";